import { useContext } from 'react'

import { SelectContext } from './SelectContext'

export function useSelectContext() {
  const context = useContext(SelectContext)

  if (!context) {
    throw new Error(
      'Child components of Card cannot be rendered outside the Card component!'
    )
  }

  return context
}
